import { Button, Input } from 'rsuite';
import { useDiagnosis } from '../../contexts/diagnosis';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  URL_TO_BANK_PAYMENT,
  getCheckDiscount,
  getCheckUnusedInvoices,
  getInvoiceOrigin,
  getProduct
} from '../../core';
import debounce from 'lodash.debounce';
import { CustomLoader } from './../../components/basic/loader';
// import Cookies from 'js-cookie';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const debouncedFetchData = debounce((func: any, query: any) => {
  func(query);
}, 1000);

export const ExaminationPaid = (props: { isAfterPaid: boolean }) => {
  const { diagnosis, setDiagnosis, isAfterPaid, setIsAfterPaid } = useDiagnosis();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState(searchParams.get('message'));
  const [inVoiceId] = useState<string | null>(searchParams.get('invoice_id') ?? '');
  const [refNumber] = useState(searchParams.get('ref_num') ?? '');

  const navigate = useNavigate();
  // const [isAfterPaid, setIsAfterPaid] = useState(props.isAfterPaid);
  const [isPaid, setIsPaid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [coupon, setCoupon] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [invoice, setInvoice] = useState<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [discount, setDiscount] = useState<any>({
    discount_amount_percent: null,
    discount_code: ''
  });

  const handleGetDiagnosis = async (id: string) => {
    try {
      const { status, data } = await getProduct(id);
      if (status === 200) {
        if (data) {
          setDiagnosis(data);
        }
      }
    } catch (e) {
      //
    }
  };
  useEffect(() => {
    const isValid = props.isAfterPaid && isAfterPaid !== 1;
    if (isAfterPaid) {
      setIsAfterPaid(0);
    }
    console.log('here', diagnosis, isValid, props.isAfterPaid, isAfterPaid);

    if (!diagnosis && !isValid) {
      navigate('/examination');
    } else {
      if (!refNumber) {
        (async () => {
          setLoading(true);
          try {
            const { status, data } = await getCheckUnusedInvoices(diagnosis.id);
            if (status === 200) {
              if (!data.invoice) {
                setIsPaid(false);
              } else {
                setInvoice(data.invoice);
                setMessage(`شما هزینه این خدمت را طی فاکتور با شماره پیگیری ${data.invoice.ref_num} پرداخت کرده اید
                و می توانید روند تشخیص را شروع کنید. بر روی دکمه شروع روند معاینه کلیک کنید.
                `);
                setIsPaid(true);
              }
            }
          } catch (e) {
            setIsPaid(false);
            //
          }
          setLoading(false);
        })();
      } else {
        (async () => {
          setLoading(true);
          try {
            const { status, data } = await getInvoiceOrigin(inVoiceId ?? '', refNumber);
            if (status === 200) {
              if (!data.invoice) {
                setIsPaid(false);
              } else {
                setInvoice(data.invoice);
                await handleGetDiagnosis(data.invoice.product_id);
                setIsPaid(true);
              }
            }
          } catch (e) {
            setIsPaid(false);
            //
          }
          setLoading(false);
        })();
      }
    }
  }, [props.isAfterPaid]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCoupon = async (params: any) => {
    console.log(params.value);
    if (params.value.length < 5) {
      setDiscount({
        discount_amount_percent: null,
        discount_code: ''
      });
      return;
    }
    // request coupon and set result
    try {
      const { data, status } = await getCheckDiscount(params.value);
      if (status === 200 && data.message === 'discount_ok_to_use') {
        setDiscount({
          discount_amount_percent: data.data.discount_amount_percent,
          discount_code: data.data.discount_code
        });
      } else {
        setDiscount({
          discount_amount_percent: 0,
          discount_code: ''
        });
      }
    } catch (e) {
      setDiscount({
        discount_amount_percent: null,
        discount_code: ''
      });
      //
    }
  };

  const handleCheckCoupon = (cop: string) => {
    debouncedFetchData(handleCoupon, { value: cop });
    setCoupon(cop);
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div
      className="relative"
      style={{
        height: '100%',
        backgroundImage: 'url("../images/abstract_bg_white.svg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
      <div
        style={{
          background:
            'linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 100%)'
        }}>
        {!diagnosis ? (
          <>
            {isAfterPaid == 0 ? (
              <>
                <div
                  className="px-5 pb-5 text-base1 text-justify text-[--rs-black] pt-10"
                  style={{ textAlignLast: 'center' }}>
                  <p style={{ lineHeight: '175%' }}>{message}</p>
                </div>
                <div className="flex items-center mt-4 pb-4">
                  <Button
                    onClick={() => navigate('/examination')}
                    appearance="primary"
                    className="!text-[--rs-black] mx-auto !rounded-xl !py-3 !px-2">
                    {' '}
                    بازگشت
                  </Button>
                </div>
              </>
            ) : (
              <CustomLoader />
            )}
          </>
        ) : (
          <>
            {isPaid && invoice ? (
              <div className="text-center pt-10">
                <p className="mb-4 text-base">{message}</p>
                <div className="bg-[--rs-yellow] text-[--rs-dark-yellow] text-center p-2 text-sm mb-4">
                  درصورت استفاده از کد تخفیف و ورود به صفحه پرداخت بانک، کد تخفیف استفاده شده تلقی
                  میشود.
                </div>
                <div className="flex items-center mt-4 pb-4">
                  <Button
                    appearance="primary"
                    className="!text-[--rs-black] mx-auto !rounded-xl !py-3 !px-2"
                    onClick={() => {
                      navigate(
                        `/examination/start/${diagnosis.type_of_algo}/${invoice.product_id}/${invoice.id}/${invoice.ref_num}/${diagnosis.id}`
                      );
                      setLoading(true);
                      setIsAfterPaid(1);
                      setDiagnosis(null);
                    }}>
                    {' '}
                    شروع روند معاینه
                  </Button>
                </div>
              </div>
            ) : (
              <div className="text-center pt-10">
                {discount.discount_amount_percent !== null ? (
                  <p className="mb-4 text-md px-4 text-[--rs-primary-800]">
                    {discount.discount_amount_percent > 0
                      ? 'کد تخفیف شما صحیح است و می توانید از آن استفاده کنید'
                      : 'کد تخفیف نامعتبر است، این کد استفاده شده یا مهلت استفاده از آن به پایان رسیده است'}
                  </p>
                ) : null}
                <p className="mb-4 text-base">نوع خدمت : {diagnosis.visit_disease_name}</p>
                <p className="mb-4 text-base">
                  هزینه خدمت {diagnosis.visit_price.toLocaleString()} ریال
                </p>
                <div className="bg-[--rs-yellow] text-[--rs-dark-yellow] text-center p-2 text-sm mb-4">
                  درصورت استفاده از کد تخفیف و ورود به صفحه پرداخت بانک، کد تخفیف استفاده شده تلقی
                  میشود.
                </div>
                <div className="mx-4">
                  <Input
                    type="text"
                    value={coupon ?? ''}
                    className={
                      discount.discount_amount_percent === null
                        ? ''
                        : discount.discount_amount_percent > 0
                          ? '!bg-[#1de9b6]'
                          : '!bg-[#f48fb1]'
                    }
                    placeholder="کد تخفیف! اگر کد تخفیف دارید اینجا وارد کنید."
                    onChange={handleCheckCoupon}
                    dir="rtl"
                  />
                </div>
                <p className="mb-4 text-md mt-5">
                  مبلغ قابل پرداخت{' '}
                  {(diagnosis.visit_price * (100 - discount.discount_amount_percent ?? 0)) / 100}{' '}
                  ریال
                </p>
                <div className="flex items-center mt-4 pb-4">
                  <Button
                    appearance="primary"
                    className="!text-[--rs-black] mx-auto !rounded-xl !py-3 !px-2"
                    onClick={() => {
                      setDiagnosis(null);
                      window.location.replace(
                        `${URL_TO_BANK_PAYMENT}Bearer ${localStorage.getItem('token')}&product_id=${diagnosis.id}&discount_code=${coupon}&came_from=pwa`
                      );
                    }}>
                    {' '}
                    {discount.discount_amount_percent ? 'اعمال کد تخفیف و پرداخت' : 'پرداخت'}
                  </Button>
                </div>
              </div>
            )}
          </>
        )}

        {/* <div className="bg-[--rs-yellow] text-[--rs-dark-yellow] text-center p-2 text-sm">
          درصورت استفاده از کد تخفیف و ورود به صفحه پرداخت بانک، کد تخفیف استفاده شده تلقی میشود.
        </div> */}
        {/*
        <div className="flex items-center mt-4 pb-4">
          <Button
            appearance="primary"
            className="!text-[--rs-black] mx-auto !rounded-xl !py-3 !px-2">
            {' '}
            شروع روند معاینه
          </Button>
        </div> */}
      </div>
    </div>
  );
};
